module.exports = __webpack_public_path__ + "static/img/articles.89d687f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles.jpg
// module id = O3OV
// module chunks = 0